import React from 'react';
import Component from '@vfuk/core-text-area-input-with-label';
const TextAreaInputWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default TextAreaInputWithLabel;
